export const DEFAULT_HISTORY_ROWS_PER_PAGE = 10;
export const HISTORY_ROWS_PER_PAGE_OPTIONS = [10, 25, 50];

export const WORKFLOW_ATTENTION_STATUSES = [
  'FAILED',
  'BLOCKED',
  'PENDING_APPROVAL',
  'RUNNING',
];

const normalize = value => String(value || '').trim().toLowerCase();

export const filterAuditHistory = (rows = [], filters = {}) => {
  const search = normalize(filters.search);
  const action = filters.action || 'ALL';
  const entity = filters.entity || 'ALL';
  return rows.filter(row => {
    if (action !== 'ALL' && row.action !== action) return false;
    if (entity !== 'ALL' && row.entityType !== entity) return false;
    if (!search) return true;
    return [row.actor || 'System', row.action, row.entityType, row.entityId, row.id]
      .some(value => normalize(value).includes(search));
  });
};

export const filterWorkflowHistory = (runs = [], filters = {}) => {
  const status = filters.status || 'ATTENTION';
  const code = filters.code || 'ALL';
  return runs.filter(run => {
    if (code !== 'ALL' && run.code !== code) return false;
    if (status === 'ALL') return true;
    if (status === 'ATTENTION') return WORKFLOW_ATTENTION_STATUSES.includes(run.status);
    return run.status === status;
  });
};

export const paginateHistory = (rows = [], requestedPage = 0, rowsPerPage = DEFAULT_HISTORY_ROWS_PER_PAGE) => {
  const pageSize = HISTORY_ROWS_PER_PAGE_OPTIONS.includes(rowsPerPage)
    ? rowsPerPage
    : DEFAULT_HISTORY_ROWS_PER_PAGE;
  const maximumPage = Math.max(0, Math.ceil(rows.length / pageSize) - 1);
  const page = Math.min(Math.max(0, requestedPage), maximumPage);
  return {
    page,
    rows: rows.slice(page * pageSize, page * pageSize + pageSize),
  };
};

export const uniqueHistoryValues = (rows = [], key) => [
  ...new Set(rows.map(row => row[key]).filter(Boolean)),
].sort((left, right) => String(left).localeCompare(String(right)));
